<template>
  <div class="home">
    <van-nav-bar
      :title="$t('ShopList.title')"
      left-arrow
      fixed
      z-index="9"
      @click-left="$router.push('/Center')"
    >
    </van-nav-bar>
    <div class="shopList">
      <van-grid :column-num="3" gutter="10">
        <van-grid-item class="addShop" @click="$router.push('/NewShop')">
          <div class="shopBj addTop">
            <van-image
              round
              width="80"
              height="80"
              src="./static/img/addShop.png"
            />
          </div>
          <div class="addBtn">
            <button class="shopname btn">
              {{ $t("ShopList.addshop") }}
            </button>
          </div>
        </van-grid-item>
        <van-grid-item v-for="(shop, index) in shops" :key="index">
          <div class="shopname1 mtop">
            <p class="shopname">{{ shop.id }}-{{ shop.name }}</p>
          </div>
          <div class="shopBj">
            <van-image
              v-if="shop.image"
              class=""
              round
              width="80"
              height="80"
              :src="shop.image.path"
            />
            <van-image
              v-else
              class="shopIcon"
              round
              width="80"
              height="80"
              src="./static/img/boss_shop_s.png"
            />
          </div>
          <p class="shoptime">
            <span>{{ showDay(shop.days) }}</span>
          </p>
          <!-- <p class="shoptime">{{ shop.created_at | formateDate }}</p> -->
          <div class="btnMain mtop">
            <button class="btn" @click="$router.push('/ShopSet/' + shop.id)">
              {{ $t("ShopList.enter") }}
            </button>
            <button class="btn yellow" @click.stop="copyShop(shop.id)">
              {{ $t("ShopList.copy") }}
            </button>
            <button class="btn red" @click="delShop(shop.id)">
              {{ $t("ShopList.delete") }}
            </button>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shops: {}
    };
  },
  mounted: function() {
    this.getShops();
  },
  computed: {
    showDay() {
      return function(val) {
        var str = "";
        if (this.$i18n.locale == "zh") {
          str = "还剩 " + val + " 天";
        } else if (this.$i18n.locale == "hk") {
          str = "還剩 " + val + " 天";
        } else if (this.$i18n.locale == "en") {
          str = val + " Days Left";
        }
        return str;
      };
    }
  },
  methods: {
    copyShop(id) {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + `/api/store/${id}/copy`
      }).then(res => {
        if (res.data.status === 200) {
          this.$toast({
            type: "success",
            message: res.data.message
          });
          setTimeout(() => {
            this.getShops();
          }, 1000);
        }
      });
    },
    getShops() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/index"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.shops = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message")
          });
        });
    },
    // 删除店铺
    delShop(id) {
      this.$dialog
        .confirm({
          title: this.$t("ShopSet.del"),
          message: this.$t("ShopSet.isDelShop"),
          confirmButtonColor: "#2f75f4",
          confirmButtonText: this.$t("vantText.confirm"),
          cancelButtonText: this.$t("vantText.cancel")
        })
        .then(() => {
          this.$axios({
            method: "DELETE",
            headers: {
              Authorization: "Bearer " + sessionStorage.token
            },
            url: this.$build + "/api/store/" + id + "/destroy"
          })
            .then(res => {
              if (res.data.status == 200) {
                this.$toast({
                  type: "success",
                  message: res.data.message
                });
                this.getShops();
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item]
                  });
                }
              }
            })
            .catch(err => {
              this.$toast({
                type: "fail",
                message: this.$t("ShopSet.message")
              });
            });
        })
        .catch(() => {});
    }
  }
};
</script>
<style>
.addShop .van-grid-item__content {
  /* padding: 20px 0 0 0!important; */
}
.addShop .van-image {
  margin: auto;
}
</style>
<style scoped>
.iconfont {
  position: absolute;
  top: 3px;
  right: 3px;
  font-size: 17px;
  padding: 5px;
}
.van-grid {
  padding: 10px 0 10px 10px !important;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
.home {
  width: 100%;
  /* min-height: 100vh; */
  background: #f3f3f3;
  /* padding: 10px; */
}
/* .shopList{
		padding-top: 56px;
	} */
/deep/ .van-grid-item__content p {
  font-size: 12px;
  text-align: center;
  margin: 0;
  padding: 0;
}
/deep/ .van-grid-item__content {
  padding: 0;
  border-radius: 5px;
  padding-bottom: 10px;
  align-items: center;
  -webkit-align-items: center;
  justify-content: flex-start;
}
.van-grid-item__content p.shopname {
  font-size: 15px;
}
.btnMain {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.btnMain .btn {
  margin: 5px;
}
.shopname1 {
  height: 30px;
  line-height: 25px;
  align-items: center;
  display: inline-flex;
}
.addBtn {
  margin-top: 2.2rem;
  height: 30px;
  line-height: 25px;
  align-items: center;
  display: inline-block;
}
.shopname {
  align-items: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.shoptime {
  font-size: 12px;
  color: #d4d4d4;
}
.shoptime span {
  color: rgb(253, 63, 63);
}
.van-image {
  align-items: center;
  -webkit-align-items: center;
  user-select: none;
}
.van-image__img {
  vertical-align: middle;
  user-select: none;
}
.shopIcon {
  margin: 10px 0 5px;
}
.shopBj {
  width: 100%;
  border-radius: 5px 5px 0 0;
  text-align: center;
}
.mtop {
  margin-top: 0.625rem;
}
.addTop {
  margin-top: 2.1875rem;
}
.btn {
  background: #2f54eb;
  border-radius: 15px;
  color: #fff;
  padding: 0.3125rem 0.9375rem;
  border: none;
  line-height: 25px;
}
.yellow {
  background: #ff6600;
}
.red {
  background: #e80000;
}
.van-button::before {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/Shop/ShopList.vue